export function parseGooglePlaceAddress(place = {}, fallback = '') {
  const components = place.address_components || [];
  const find = (type, mode = 'long_name') => components.find(component => component.types?.includes(type))?.[mode] || '';
  const logradouro = find('route');
  const numero = find('street_number');
  const bairro = find('sublocality_level_1') || find('sublocality') || find('neighborhood');
  const cidade = find('administrative_area_level_2') || find('locality');
  const uf = find('administrative_area_level_1', 'short_name');
  const cep = find('postal_code');
  const endereco_formatado = place.formatted_address || fallback || '';
  return {
    endereco: endereco_formatado,
    endereco_formatado,
    logradouro,
    numero,
    bairro,
    cidade,
    uf,
    cep,
    lat: place.latitude ?? null,
    lng: place.longitude ?? null,
    google_place_id: place.place_id || '',
  };
}

export function emptyAddressFields() {
  return { endereco: '', endereco_formatado: '', logradouro: '', numero: '', bairro: '', cidade: '', uf: '', cep: '', complemento: '', lat: null, lng: null, google_place_id: '' };
}

export function hasPersonAddress(person = {}) {
  return Boolean(person.endereco_formatado || person.endereco || person.logradouro || person.lat || person.lng);
}